import { render, staticRenderFns } from "./form-qualification-age.vue?vue&type=template&id=37c89f1f&scoped=true"
import script from "./form-qualification-age.vue?vue&type=script&lang=js"
export * from "./form-qualification-age.vue?vue&type=script&lang=js"
import style0 from "./form-qualification-age.vue?vue&type=style&index=0&id=37c89f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c89f1f",
  null
  
)

export default component.exports